// 倒计时
function getRandomNum(min, max) {
  return Math.floor(Math.random() * (max - min)) + min
}

let endTimeG
var imgArr = [
  'https://cdn.shopify.com/s/files/1/0619/5537/5156/files/f5cda06d043f6fd31adabf27fa45f584.png',
  'https://cdn.shopify.com/s/files/1/0619/5537/5156/files/f5cda06d043f6fd31adabf27fa45f584.png',
  'https://cdn.shopify.com/s/files/1/0619/5537/5156/files/f5cda06d043f6fd31adabf27fa45f584.png',
  'https://cdn.shopify.com/s/files/1/0619/5537/5156/files/f5cda06d043f6fd31adabf27fa45f584.png',
  'https://cdn.shopify.com/s/files/1/0619/5537/5156/files/buy_1.png?v=1762253209',
  'https://cdn.shopify.com/s/files/1/0619/5537/5156/files/f5cda06d043f6fd31adabf27fa45f584.png',
]
var imgArr2 = [
  'https://cdn.shopify.com/s/files/1/0619/5537/5156/files/f5cda06d043f6fd31adabf27fa45f584.png',
  'https://cdn.shopify.com/s/files/1/0619/5537/5156/files/20251110-pro1.png?v=1762769952',
]
function cutDownTime() {
  let nowTime = new Date()
  let endTime = new Date(endTimeG)

  let leftTime = endTime.getTime() - nowTime.getTime()
  if (leftTime < 0) {
    setupNewCountdown()
    leftTime = 0
  }
  let leftH = Math.floor((leftTime / (1000 * 60 * 60)) % 24),
    leftM = Math.floor((leftTime / (1000 * 60)) % 60),
    leftS = Math.floor((leftTime / 1000) % 60)
  leftH = leftH >= 10 ? leftH : '0' + leftH
  leftM = leftM >= 10 ? leftM : '0' + leftM
  leftS = leftS >= 10 ? leftS : '0' + leftS

  return {
    hour: leftH,
    minute: leftM,
    second: leftS,
  }
}
function setupNewCountdown() {
  const randomHour = getRandomNum(1, 9)
  const currentTime = new Date()
  endTimeG = currentTime.setHours(currentTime.getHours() + randomHour)
}
let intervalId

function getCutDownTime() {
  setupNewCountdown()
  if (intervalId) clearInterval(intervalId)
  intervalId = setInterval(function () {
    let cutDownTimeText = cutDownTime()
    $('.sp_top_cut_down .sp_left_view .sp_hour').html(cutDownTimeText.hour)
    $('.sp_top_cut_down .sp_left_view .sp_minute').html(cutDownTimeText.minute)
    $('.sp_top_cut_down .sp_left_view .sp_second').html(cutDownTimeText.second)
  }, 1000)
}

getCutDownTime()

function mainRender() {
  $(function () {
    $('#root').css('zoom', 'normal')
    let scale = document.body.clientWidth / 1080
    $('#root').css('zoom', scale)

    window.addEventListener(
      'resize',
      (function () {
        var timer
        return function () {
          if (timer) clearTimeout(timer)
          timer = setTimeout(function () {
            $('#root').css('zoom', 'normal')
            let scale = document.body.clientWidth / 1080
            $('#root').css('zoom', scale)
          }, 100)
        }
      })()
    )
  })

  function lazyLoadImages() {
    // 懒加载
    const images = document.querySelectorAll('.lazy-load') // 获取所有需要懒加载的图片
    const config = {
      rootMargin: '0px 0px 1300px 0px',
      threshold: 0,
    }

    const lazyLoadObserver = new IntersectionObserver(function (
      entries,
      observer
    ) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          // 当图片进入视口时
          const image = entry.target
          const dataSrc = image.getAttribute('data-src')
          image.src = dataSrc // 将data-src属性的值设置为图片的实际地址
          lazyLoadObserver.unobserve(image) // 停止观察该图片
        }
      })
    },
    config)

    images.forEach(function (image) {
      lazyLoadObserver.observe(image) // 开始观察每个图片
    })
  }

  function preloadImages(imageArray) {
    // 预加载
    // 检查数组数据结构
    if (Array.isArray(imageArray[0])) {
      // 处理二维数组
      imageArray.forEach(subArray => {
        subArray.forEach(url => {
          const img = new Image()
          img.src = url
        })
      })
    } else {
      // 处理一维数组
      imageArray.forEach(url => {
        const img = new Image()
        img.src = url
      })
    }
  }
  preloadImages(imgArr)
  document.addEventListener('DOMContentLoaded', function () {
    lazyLoadImages()

    new Swiper('.sp-swiper1', {
      speed: 5000,
      autoplay: true,
      autoplay: {
        delay: 1,
        disableOnInteraction: false,
      },
      slideShadows: true,
      slidesPerView: 'auto',
      spaceBetween: 0,
      loop: true,
    })

    $('.reduce').click(function () {
      let input = $(this).siblings('input')[0]
      let num = Number(input.value) - 1
      if (num > 0) {
        input.value = num
        $('#price1').html((19.99 * num).toFixed(2) + '')
        $('#price2').html((39.99 * num).toFixed(2) + '')
      }
    })
    $('.add').click(function () {
      let input = $(this).siblings('input')[0]
      let num = Number(input.value) + 1
      input.value = num
      $('#price1').html((19.99 * num).toFixed(2) + '')
      $('#price2').html((39.99 * num).toFixed(2) + '')
    })

    $('.sp-btn-style').click(function () {
       let num = $('#calcNumber').val()
       num == undefined ? num = 1 : '';
       let id = getCur().id
       let more = $(this).attr('data-more')
       let active = $(this).parent().parent().find(".sp-check div").hasClass("active");
       active ? id = more : "";
       window.location.href = '/cart/' + id + ':' + num;
      // var items = [{
      //     quantity: num,
      //     variant_id: id,
      //     note: '',
      // }]
      // $.post('/api/checkout/order', {
      //     line_items: items,
      //     refer_info: { source: 'buy_now' }
      // }, function (ret) {
      //     if (ret.state === 'success') {
      //         return (window.safeHref = '/checkout/' + ret.data.order_token + '?step=contact_information');
      //     } else {
      //         $.toast.show({
      //             content:
      //                 {
      //                     '30003': "Some items have been removed, please re-order",
      //                     'line_items_variant_withdraw': "Some items have been sold out, please re-order",
      //                     'line_items_variant_sold_out': "Some items are not in stock, please re-order"
      //                 }[ret.state] || ret.errors[0] || "Some items information has been updated, please re-order"
      //         });
      //     }
      // });
    })

    $('.product-box .sp-check div').click(function () {
      $(this).toggleClass('active')
      const productBox = $(this).closest('.product-box')
      const imgWrap = productBox.find('.img-wrap')

      if ($(this).hasClass('active')) {
        imgWrap.find('.p-img').hide().eq(1).show()
        productBox.find('.sp-round').css('left', '262px')
        productBox.find('.title-s span').show()
        productBox.find('.title-s2').show()
        productBox.find('.price-group').hide()
        productBox.find('.price-group2').show()
        productBox.find('.addGroup').hide()
        productBox.find('.sp-univalent').hide()
        productBox.find('.sp-univalent2').show()
      } else {
        imgWrap.find('.p-img').hide().eq(0).show()
        productBox.find('.sp-round').css('left', '395px')
        productBox.find('.title-s span').hide()
        productBox.find('.title-s2').hide()
        productBox.find('.price-group').show()
        productBox.find('.price-group2').hide()
        productBox.find('.addGroup').show()
        productBox.find('.sp-univalent').show()
        productBox.find('.sp-univalent2').hide()
      }
    })

    // 为 .sp-hand 添加点击事件，触发对应的 .sp-check div
    $('.product-box .sp-hand').click(function () {
      const productBox = $(this).closest('.product-box')
      const checkDiv = productBox.find('.sp-check div')
      checkDiv.click() // 触发对应的复选框点击事件
    })

    // 为 .sp-part9 .btn-style 添加点击事件，自动勾选所有套餐
    $('.sp-part9 .btn-style').click(function () {
      $('.product-box .sp-check div').each(function () {
        if (!$(this).hasClass('active')) {
          $(this).click() // 触发点击事件，自动执行上面的逻辑
        }
      })

      const targetElement = document.getElementById('shopping') // 获取跳转目标节点
      const offsetTop = targetElement.offsetTop
      window.scroll({
        top:
          offsetTop * $('div#root').css('zoom') +
          360 * $('div#root').css('zoom'),
        behavior: 'smooth', // 使用 smooth 实现平滑滚动
      }) // 方式二
    })

    $('.product-box .sp-option div').click(function () {
      $(this).toggleClass('active')
      const productBox = $(this).closest('.product-box')
      const imgWrap = productBox.find('.img-wrap')
      if ($(this).hasClass('active')) {
        imgWrap.find('.p-img').hide().eq(1).show()
      }
    })
    let prods = window.product
    function getCur() {
      let color = $('#color div.active').attr('data-val')
      let type = $('#type div.active').attr('data-val')
      return prods.filter(item => item.option1 == color && item.option2 == type)[0]
    }

    function changePrice() {
      let num = $('#calcNumber').val()
      let price = ((getCur().price * num) / 100).toFixed(2)
      let compare = ((getCur().compare_at_price * num) / 100).toFixed(2)
      // if(num == 1){
      //   price = (getCur().price * num / 100).toFixed(2)
      // }else if(num == 2){
      //   price = (getCur().price * num / 100 * 0.95).toFixed(2)
      // }else if(num == 3){
      //   price = (getCur().price * num / 100 * 0.9).toFixed(2)
      // }else {
      //   price = (getCur().price * num / 100 * 0.85).toFixed(2)
      // }
      // price = (price + '').replace('.', ',')
      // compare = (compare + '').replace('.', ',')
      $('#new').html(price)
      $('#old').html(compare)
      // let off_font =
      //   100 - Math.ceil((getCur().price / getCur().compare_at_price) * 100)
      // $('.product-part .price-group .sp-row p span').html(off_font)
    }
    // 数字框
    $('.reduce').click(function () {
      let input = $(this).siblings('input')[0]
      let num = Number(input.value) - 1
      if (num > 0) {
        input.value = num
      }
      changePrice()
    })
    $('.add').click(function () {
      let input = $(this).siblings('input')[0]
      let num = Number(input.value) + 1
      input.value = num
      changePrice()
    })
    const textarr = ['x2', 'x4', 'x10', 'x10']
    let colorOptions = $('#color .option')
    let typeOptions = $('#type .option')

    // typeOptions.click(function () {
    //   let index = $(this).index()
    //   $(this).addClass('active').siblings().removeClass('active')
    //   const text = $(this).attr('data-val')
    // //   $('.top-product>img').attr('src', imgArr[index])
    //   $('.sp-option-text').html(text)
    //   if (index >= 1) {
    //     if (index == 4) {
    //       $('.sp-round').css('right', '410px')
    //     } else {
    //       $('.sp-round').css('right', '250px')
    //     }
    //     $('.sp-round').text(textarr[index - 1])
    //     $('.sp-round').show()
    //   } else {
    //     $('.sp-round').hide()
    //   }

    //   changePrice()
    // })

    $('.option').click(function () {
      $(this).addClass('active').siblings().removeClass('active')
      let index2 = $('#color .option.active').index()
      let index = $('#type .option.active').index()
      const text = $(this).attr('data-val')
    //   $('.top-product>img').attr('src', imgArr[index])
      $('.sp-option-text').html(text)
      if (index2 >= 1) {
        $('.sp-round').text(textarr[index2 - 1])
        $('.sp-round').show()
      } else {
         $('.sp-round').hide()
        }

 
    //   $('.top-product>img').attr('src', imgArr2[index2])

      changePrice()
    })
    // 展开
    $('.sp-pro-shopping>ul li i').click(function () {
      if ($(this).siblings('div').children('p').hasClass('makeup') == true) {
        $(this).removeClass('sp-makeup')
        $(this).siblings('div').children('p').removeClass('makeup')
      } else {
        $(this).addClass('sp-makeup')
        $(this).siblings('div').children('p').addClass('makeup')
      }
    })
    // style选项
    $('.cart-btn').click(function () {
      $(this).children('img').addClass('on')
      setTimeout(function () {
        $('.cart-btn').children('img').removeClass('on')
      }, 500)
      $('.sp-header-top .sp-cart').addClass('on')
      setTimeout(function () {
        $('.sp-header-top .sp-cart').removeClass('on')
      }, 500)
    })
    // 弹窗 start
    var main_id = ''
    var main_num = 1
    $('.emitCheckout').click(function () {
      console.log('1111')
      let num = $('#calcNumber').val()
      let id = getCur().id

      main_id = id
      main_num = num
      //  main_id = $(this).siblings('.select_span').find('span.on').data('id')
      //  window.location.href = "/cart/" + id + ':' + num
    })

    function getPopProdId() {
      let selectVals = []
      $('.overbuy_wrap .sp-subopt.active').each(function () {
        selectVals.push($(this).data('val'))
      })

      let cur = popProduct.filter(item => {
        let option1 = selectVals[0]
        let option2 = null
        let option3 = null
        if (selectVals[1]) {
          option2 = selectVals[1]
        }
        if (selectVals[2]) {
          option3 = selectVals[2]
        }

        return (
          item.option1 == option1 &&
          item.option2 == option2 &&
          item.option3 == option3
        )
      })

      return cur[0]
    }

    $('.overbuy-select div').click(function () {
      $(this).siblings().removeClass('active')
      $(this).addClass('active')
      let cur = getPopProdId()

      if (cur) {
        $('.main-btn').text('GET 8% oFF').removeClass('overbuy_disabled')
        let _price = parseFloat(cur.price / 100).toFixed(2)
        let _compare_at_price = parseFloat(cur.compare_at_price / 100).toFixed(
          2
        )

        $('.overbuy_price span')
          .eq(0)
          .html('£' + _price)
        $('.overbuy_price span')
          .eq(1)
          .html('£' + _compare_at_price)
      } else {
        $('.main-btn').text('Unavailable').addClass('overbuy_disabled')
      }
    })

    window.emitSubmit = function (_type) {
      let num = $('#calcNumber').val()
      if (_type == 'all') {
        // var bundle_sku = data[$('input[name="overbuy1"]:checked').val()][$('input[name="overbuy2"]:checked').val()]
        let _id = getPopProdId()?.id
        if (!_id) return
        console.log(_id)

        window.location.href = `/cart/${main_id}:${main_num},${_id}:1`
      } else {
        window.location.href = `/cart/${main_id}:${main_num}`
      }
    }

    // 弹窗 end
    // 加入购物车
    addCart()
    function addCart() {
      // 加入购物车
      $('.addCerts').click(function () {
        // do something here
        // var number =
        //   Number($('.sp-cart #cardNum').html()) + Number($('#calcNumber').val())
        // $('.sp-cart #cardNum').html(number)
        // if (number > 0) {
        //   $('.sp-cart .num').css('background', '#cf0101')
        // } else {
        //   $('.sp-cart .num').css('background', '#919191')
        // }
        let data = {
          id: getCur().id,
          quantity: $('#calcNumber').val(),
        }
        $.ajax({
          type: 'POST',
          url: '/cart/add.js',
          data: data,
          success: function () {
            $.getJSON(
              window.Shopify.routes.root + 'cart.js',
              function (result) {
                $('#cardNum').html(result.item_count)
                $('#cardNum').removeClass('sp-gray')
              }
            )
          },
          dataType: 'json',
        })

        var img = $('.top-product img')
        var flyer = img[0].cloneNode(true)
        flyer.classList.add('clone')
        $('.product-part').append(flyer)
        $('.clone').css({
          width: img.width(),
          height: img.height(),
          position: 'fixed',
          top: img[0].offsetTop,
          left: img.offset().left,
          'z-index': '99',
        })
        var offset = $('.sp-cart')[0].getBoundingClientRect()
        $('.sp-cart').addClass('shake')
        setTimeout(() => {
          $('.sp-cart').removeClass('shake')
        }, 1000)
        let finish = $('.sp-cart')
        $('.clone').animate(
          {
            top: finish[0].offsetTop + 137,
            left: finish[0].offsetLeft + finish.width() / 2 - 15,
            width: 50, // 结束时的大小，根据需要调整
            height: 50, // 结束时的大小，根据需要调整
            opacity: 0.4,
          },
          1000,
          'linear',
          function () {
            $(this).animate(
              {
                width: 0,
                height: 0,
                opacity: 0,
              },
              0,
              function () {
                $(this).detach() // 完成动画后移除克隆的图片
              }
            )
          }
        )
      })
    }
    // 找到所有跳转套餐的锚点链接
    var links = document.querySelectorAll('a[href^="#shopping"]')
    links.forEach(function (link) {
      link.addEventListener('click', function (event) {
        event.preventDefault() // 阻止默认的跳转行为
        // var targetElement = document.getElementById('shopping');
        // if (targetElement) {
        //     targetElement.scrollIntoView({ behavior: 'smooth' });
        // } // 方式一
        const targetElement = document.getElementById('shopping') // 获取跳转目标节点
        const offsetTop = targetElement.offsetTop
        window.scroll({
          top:
            offsetTop * $('div#root').css('zoom') -
            255 * $('div#root').css('zoom'),
          behavior: 'smooth', // 使用 smooth 实现平滑滚动
        }) // 方式二
      })
    })
  })

  // IOS字体多了间距的处理 给节点添加 sp_system 类名
  // 判断当前用户是安卓端还是iOS端
  var userAgent = navigator.userAgent || navigator.vendor || window.opera
  var isAndroid = /android/i.test(userAgent)
  var isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream
  var isPC = !isAndroid && !isIOS && !/Iron/.test(userAgent) // 添加了对 "Iron" 关键词的判断

  if (isAndroid) {
    console.log('Android')
  } else if (isIOS) {
    console.log('iOS')
  } else if (isPC) {
    console.log('PC')
  } else {
    $('.sp_system').css('letter-spacing', '-4px')
  }

  // 标题文本渐出
  const graduallyList = document.getElementsByClassName('gradually')
  for (let gradually of graduallyList) {
    const spans = gradually.querySelectorAll('span')
    const paragraph = gradually.querySelector('.sp-detail')

    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            // 给每个 span 和 i 动画
            spans.forEach((span, index) => {
              span.style.animation = `swift-up-fade 0.5s ease forwards`
              span.style.animationDelay = `${index * 0.1}s`

              const i = span.querySelector('i')
              if (i) {
                i.style.animation = `swift-up-fade 0.5s ease forwards`
                i.style.animationDelay = `${index * 0.1}s`
              }
            })

            // 段落
            const totalDelay = spans.length * 0.1 + 0.3
            if (paragraph) {
              paragraph.style.animation = `swift-up-fade 0.5s ease forwards`
              paragraph.style.animationDelay = `${totalDelay}s`
            }

            observer.unobserve(gradually)
          }
        })
      },
      {
        threshold: 0.3,
      }
    )
    observer.observe(gradually)
  }
}

mainRender()
